import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { t } from 'i18next';

import { Box, styled } from '@mui/material';

import {
  Button,
  KeyIcon,
  Typography,
} from '@datanomik/commons-ui';

import { LinkUnlink } from '@datanomik/commons-ui/icons';

import { useUserContext } from '../../../contexts/user';

import { styles } from './styles';

const ReportScheduleExceptionRaw = ({ className }) => {
  const { userIsLogged } = useUserContext();

  const navigateRedirect = useNavigate();

  const handleRedirect = () => {
    navigateRedirect('/');
  };

  return (
    <Box className={className}>
      <Box width="420px">
        <KeyIcon size="xlarge" color="red">
          <LinkUnlink />
        </KeyIcon>
        <Typography variant="h5" mt="16px">
          {t('The link to your report has expired.')}
        </Typography>
        {
          userIsLogged() ? (
            <Box mt="24px">
              <Button fullWidth onClick={handleRedirect}>
                {t('Back to home page')}
              </Button>
            </Box>
          ) : (
            <>
              <Typography variant="p3" mb="24px" color="text.500">
                {t('Login to the platform to generate a new report.')}
              </Typography>
              <Button fullWidth onClick={handleRedirect} size="large">
                {t('Back to login page')}
              </Button>
            </>
          )
        }
      </Box>
    </Box>
  );
};

ReportScheduleExceptionRaw.propTypes = {
  className: PropTypes.string,
};

const ReportScheduleException = styled(ReportScheduleExceptionRaw)(styles);
ReportScheduleException.propTypes = ReportScheduleExceptionRaw.propTypes;

export const ReportScheduleExceptionPublic = () => (
  <ReportScheduleException />
);
